<template>
  <div class="relative w-auto" 
    ref="tooltipTrigger"
    @mouseenter="onMouseEnter" 
    @mouseleave="hide"
    @click="hide"
    @pointerdown="hide">
    <slot />
    <Teleport to="body">
      <div
        v-if="visible && displayText"
        @click="hide"
        ref="tooltipElement"
        class="fixed p-2 text-sm text-white bg-gray-800 rounded shadow-lg w-auto min-w-[75px] text-center dark:text-slate-800 dark:bg-white pointer-events-none"
        :class="[props.class]"
        :style="dropdownStyle"
      >
        {{ displayText }}
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useTeleportTooltip } from '@/composables/useTeleportTooltip.js';

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  position: {
    type: String,
    default: 'top', // Options: top, bottom, left, right
  },
  class: {
    type: String,
    default: '',
  },
  zIndex: {
    type: [String, Number],
    default: '50',
  },
});

const { te, t } = useI18n();

const displayText = computed(() => {
  if (!props.text) return '';
  if (te(props.text)) {
    return t(props.text);
  }
  return props.text;
});

const {
  visible,
  tooltipTrigger,
  tooltipElement,
  dropdownStyle,
  show,
  hide
} = useTeleportTooltip({
  position: props.position,
  zIndex: computed(() => String(props.zIndex))
});

const onMouseEnter = () => {
  if (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    show();
  }
};
</script>